import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';

export default function PageScroller() {
  return (
    <div style={{ display: 'flex' }}>
      <Button
        type="text"
        icon={<UpOutlined />}
        title="Scroll to top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      />
      <Button
        type="text"
        icon={<DownOutlined />}
        title="Scroll to bottom"
        onClick={() => window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })}
      />
    </div>
  );
}
